import type { StudyCampaignReferenceSelectDto } from '@@types/api.types';
import { CampaignStatusBadge } from '@components/shared/campaign-status-badge.component';
import { Tile } from '@components/shared/tile.component';
import { routes } from '@routes';
import { ArrowRightIcon } from 'lucide-react';
import type { FC } from 'react';
import { Link } from 'react-router-dom';

type MeiaReferencingCampaignsTileProps = {
  referencingCampaigns: StudyCampaignReferenceSelectDto[];
};

export const MeiaReferencingCampaignsTile: FC<MeiaReferencingCampaignsTileProps> = (props) => {
  const { referencingCampaigns } = props;

  if (referencingCampaigns.length === 0) return null;

  return (
    <Tile
      contentClassName="gap-3"
      header={{ title: 'Campaigns referencing this study' }}
    >
      <div className="flex flex-col gap-2">
        {referencingCampaigns.map((reference) => (
          <Link
            className="flex items-center justify-between gap-2 rounded-md border border-gray-200 px-3 py-2 transition-colors hover:border-gray-300 hover:bg-gray-50"
            key={reference.id}
            to={`${routes.campaigns.path}/${reference.campaignId}`}
          >
            <div className="flex min-w-0 flex-wrap items-center gap-2">
              <span className="truncate text-sm font-medium text-gray-800">{reference.campaignName}</span>
              <CampaignStatusBadge status={reference.campaignStatus} />
            </div>
            <ArrowRightIcon className="size-4 shrink-0 text-gray-400" />
          </Link>
        ))}
      </div>
    </Tile>
  );
};
